import { Translation } from "react-i18next";
import i18n from "i18next";

export const translate = (key) => {
    return <Translation>{(t, { i18n }) => t(key)}</Translation>;
};
export const textTranslate = (key, options) => (i18n.t(key, options));